module.exports = __webpack_public_path__ + "static/wechat_pay_johnson-aede9f30158e67d970feaf9e66ec2ad7.jpg";